import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import LoadingSpinner from "./components/LoadingSpinner";
import PrivateRoute from "./components/PrivateRoute";
import ScrollToTop from "./components/ScrollToTop";

const Home = lazy(() => import("./pages/Home"));
const LoginPage = lazy(() => import("./pages/LoginPage2"));
const HomePage = lazy(() => import("./pages/HomePage"));
const MusicasEncontrar = lazy(() => import("./pages/MusicasEncontrar"));
const MusicaCadastrar = lazy(() => import("./pages/MusicaCadastrar"));
const ListasSalvas = lazy(() => import("./pages/ListasSalvas"));
const RecuperarSenha = lazy(() => import("./pages/RecuperarSenha"));
const RedefinirSenha = lazy(() => import("./pages/RedefinirSenha"));
const PoliticasUso = lazy(() => import("./pages/PoliticasUso"));
const PoliticaPrivacidade = lazy(() => import("./pages/PoliticaPrivacidade"));
const TermosDeUso = lazy(() => import("./pages/TermosDeUso"));
const PoliticaCookies = lazy(() => import("./pages/PoliticaCookies"));
const Contatos = lazy(() => import("./pages/Contatos"));
const Sobre = lazy(() => import("./pages/Sobre"));
const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const PageDoacao = lazy(() => import("./pages/PageDoacao"));
const OracoesEucaristicas = lazy(() => import("./pages/OracoesEucaristicas"));
const LiturgiaDoDia = lazy(() => import("./pages/LiturgiaDoDia"));
const TestConnection = lazy(() => import("./pages/TestConnection"));
const Tutorial = lazy(() => import("./pages/Tutorial"));
const AssinaturaSucesso = lazy(() => import("./pages/AssinaturaSucesso"));
const VerifyMagicLinkPage = lazy(() => import("./pages/VerifyMagicLinkPage"));

function AppRoutes() {
  return (
    <Router>
      <ScrollToTop />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route
            path="/"
            element={
              localStorage.getItem("token") ? (
                <Navigate to="/homepage" />
              ) : (
                <Home />
              )
            }
          />
          <Route path="/recuperar-senha" element={<RecuperarSenha />} />
          <Route path="/redefinir-senha" element={<RedefinirSenha />} />
          <Route
            path="/homepage"
            element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/listas-salvas"
            element={
              <PrivateRoute>
                <ListasSalvas />
              </PrivateRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/politicas-de-uso" element={<PoliticasUso />} />
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/termos-de-uso" element={<TermosDeUso />} />
          <Route path="/politica-cookies" element={<PoliticaCookies />} />
          <Route path="/contatos" element={<Contatos />} />
          <Route path="/sobre" element={<Sobre />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route
            path="/musicas/encontrar"
            element={
              <PrivateRoute>
                <MusicasEncontrar />
              </PrivateRoute>
            }
          />
          <Route
            path="/musicas/cadastrar"
            element={
              <PrivateRoute>
                <MusicaCadastrar />
              </PrivateRoute>
            }
          />
          <Route path="/cadastrar" element={<Navigate to="/assinar" />} />
          <Route path="/doacao" element={<Navigate to="/assinar" />} />
          <Route path="/assinar" element={<PageDoacao />} />
          <Route
            path="/oracoes-eucaristicas"
            element={<OracoesEucaristicas />}
          />
          <Route path="/liturgia-do-dia" element={<LiturgiaDoDia />} />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/assinatura-sucesso" element={<AssinaturaSucesso />} />
          <Route path="/verificar-acesso" element={<VerifyMagicLinkPage />} />
          <Route path="/test-connection" element={<TestConnection />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRoutes;